'use strict';

angular.module('ClinicApp').factory('FeedbackService', function($http, ClinicConfig) {
  return {
    submitFeedback: function(params, feedbackId) {
      return $http[feedbackId ? 'put' : 'post'](ClinicConfig.HOSTNAME + '/feedback' + (feedbackId ? '/' + feedbackId : ''), params, {
        withCredentials: true,
      }).then(function(response) {
        return response.data;
      });
    },
  };
});
